"use strict";
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * @module contacts
 * @description  This module provides the functionality to the Web Portal for the
 * management of a User's contacts.
 */

module.exports = function (config, get, post) {
	/**
	 * Lists the user's contacts
	 * @param  {String} token User's session token (optional)
	 * @return {Promise}      Resolves to array of contact data
	 */
	function list() {
		return get("/v2/contacts/list", {});
	}

	/**
	 * Removes a contact
	 * @param  {String} who   Id of user to remove
	 * @return {Promise}      Resovles if successful
	 */
	function remove(who) {
		return post("/v2/contacts/list/remove", {
			who: who
		});
	}

	/**
	 * Lists incoming contact requests
	 * @return {Promise}      Resolves to array of incoming requests and users
	 */
	function incoming() {
		return get("/v2/contacts/requests/incoming", {});
	}

	/**
	 * Lists outgoing contact requests
	 * @return {Promise}      Resolves to array of outgoing requess and users
	 */
	function outgoing() {
		return get("/v2/contacts/requests/outgoing", {});
	}

	/**
	 * Creates a contact request to a certain user
	 * @param  {String} to    Id of user to send request to
	 * @return {Promise}      Resolves to request id and info
	 */
	function request(to) {
		return post("/v2/contacts/request", {
			to: to
		});
	}

	/**
	 * Cancels an outgoing contact request
	 * @param  {String} request ID of request to cancel
	 * @return {Promise}        Resolves if request was cancelled
	 */
	function cancel(request) {
		return post("/v2/contacts/request/cancel", {
			request: request
		});
	}

	/**
	 * Accepts an incoming contact request
	 * @param  {String} request Id of the request to accept
	 * @return {Promise}        Resolves if request was accepted
	 */
	function accept(request) {
		return post("/v2/contacts/request/accept", {
			request: request
		});
	}

	/**
	 * Denies an incoming contact request
	 * @param  {String} request ID of request to deny
	 * @return {Promise}        Resovles if the request was denied
	 */
	function deny(request) {
		return post("/v2/contacts/request/deny", {
			request: request
		});
	}

	/**
	 * Sends out a new invite to a person's email
	 * @param  {String}  email The email of the person to invite
	 * @return {Promise}       Resolves to invite information
	 */
	function send_invite(email, language) {
		return post("/v2/contacts/invite/send", {
			email: email,
			language: language
		});
	}

	/**
	 * Cancls an outgoing account invite
	 * @param  {String}  invite The id of the invite to cancel
	 * @return {Promise}        Resolves if the invite was cancelled
	 */
	function cancel_invite(invite) {
		return post("/v2/contacts/invite/cancel", {
			invite: invite
		});
	}

	/**
	 * Lists all pending invites
	 * @return {Promise} Resolves to array of invites
	 */
	function list_invites() {
		return get("/v2/contacts/invite/list", {});
	}

	function settings_list(){
		return get("/v2/contacts/settings/list");
	}

	function settings_list_own(){
		return get("/v2/contacts/settings/list/own");
	}

	function settings_update(settings, contact){
		return post("/v2/contacts/settings/update", {
			settings: settings,
			contact: contact
		});
	}

	return {
		requests: {
			incoming: incoming,
			outgoing: outgoing,
			request: request,
			cancel: cancel,
			accept: accept,
			deny: deny
		},
		invite: {
			send: send_invite,
			cancel: cancel_invite,
			list: list_invites
		},
		settings: {
			list: settings_list,
			listOwn: settings_list_own,
			update: settings_update
		},
		list: list,
		remove: remove
	};
};
